/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 给手机发送手机验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  identifyCaptchaReq: member.IdentifyCaptchaReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/pay/password/captcha`,
    data: identifyCaptchaReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
